export const TICKET_STATUS_OPTIONS = [
  { value: "OPEN", label: "Open", hint: "open and unresolved" },
  { value: "WITH_VENDOR", label: "With vendor", hint: "waiting on the vendor" },
  { value: "RESOLVED", label: "Resolved", hint: "resolved and fixed" },
  { value: "CLOSED_NO_FIX", label: "Closed (no fix)", hint: "closed without a fix" },
  { value: "DUPLICATE", label: "Duplicate", hint: "duplicate of another ticket" }
] as const;

export const INTAKE_STATUS_OPTIONS = TICKET_STATUS_OPTIONS.filter(o => o.value !== "DUPLICATE");

export const TICKET_ORIGIN_OPTIONS = [
  { value: "INTERNAL", label: "Internal", hint: "internal notes with no vendor contact" },
  { value: "CLIENT", label: "Client", hint: "raised by the client, e.g. a forwarded client email or call" },
  { value: "WALKME_SUPPORT", label: "WalkMe support", hint: "raised by WalkMe support or through the WalkMe Community Portal" },
  { value: "OTHER", label: "Other", hint: "other origin" }
] as const;

export const PRODUCT_AREA_OPTIONS = [
  { value: "SMART_WALK_THRU", label: "Smart Walk-Thru (SWT)", hint: "Smart Walk-Thru" },
  { value: "EDITOR", label: "Editor", hint: "Editor" },
  { value: "CONSOLE", label: "Console", hint: "Console" },
  { value: "INSIGHTS", label: "Insights", hint: "Insights" },
  { value: "EXTENSION", label: "Extension", hint: "Extension" },
  { value: "LEARNING_ARC", label: "Learning arc", hint: "Learning Arc" },
  { value: "SMART_TIPS", label: "Smart tips", hint: "Smart Tips" },
  { value: "LAUNCHERS", label: "Launchers", hint: "Launchers" },
  { value: "FLOW_TRACKER", label: "Flow tracker", hint: "Flow Tracker" },
  { value: "SEGMENTS", label: "Segments", hint: "Segments" },
  { value: "ASSISTANT", label: "Assistant", hint: "Assistant" },
  { value: "INTEGRATIONS", label: "Integrations", hint: "Integrations" },
  { value: "OTHER", label: "Other", hint: "Other" }
] as const;

export const ENVIRONMENT_OPTIONS = [
  { value: "PROD", label: "Production", hint: "Production" },
  { value: "DEVELOPMENT", label: "Development", hint: "Development" },
  { value: "TEST", label: "Test", hint: "Test" },
  { value: "OTHER", label: "Other", hint: "Other" }
] as const;

export const RESOLUTION_TYPE_OPTIONS = [
  { value: "CONFIG", label: "Config", hint: "Config" },
  { value: "PRODUCT_BUG", label: "Product bug", hint: "Product Bug" },
  { value: "PRODUCT_LIMITATION", label: "Product limitation", hint: "Product Limitation" },
  { value: "USER_GUIDANCE", label: "User guidance", hint: "User Guidance" },
  { value: "WORKAROUND", label: "Workaround", hint: "Workaround" },
  { value: "NO_FIX", label: "No fix", hint: "No Fix" }
] as const;

export const TICKET_STATUS_VALUES = TICKET_STATUS_OPTIONS.map(o => o.value) as unknown as readonly [string, ...string[]];
export const TICKET_ORIGIN_VALUES = TICKET_ORIGIN_OPTIONS.map(o => o.value) as unknown as readonly [string, ...string[]];
export const PRODUCT_AREA_VALUES = PRODUCT_AREA_OPTIONS.map(o => o.value) as unknown as readonly [string, ...string[]];
export const ENVIRONMENT_VALUES = ENVIRONMENT_OPTIONS.map(o => o.value) as unknown as readonly [string, ...string[]];
export const RESOLUTION_TYPE_VALUES = RESOLUTION_TYPE_OPTIONS.map(o => o.value) as unknown as readonly [string, ...string[]];

type Option = { value: string; label: string; hint?: string };

export function labelFor(options: readonly Option[], value: string | null | undefined): string {
  if (!value) return "";
  const opt = options.find(o => o.value === value);
  return opt ? opt.label : value;
}

export function isOptionValue<T extends { value: string }>(options: readonly T[], value: unknown): value is T["value"] {
  if (typeof value !== "string") return false;
  return options.some(o => o.value === value);
}
